<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_CONSULTANDO' | translate }}</span>
  </div>
</div>

<div *ngIf="!carInformacionInicial">
  <div class="grid">
    <div class="col-12 md:col-12 lg:col-12">
      <p-panel header="{{ 'MATRIZIDENTIDAD.LBL_MATRIZIDENTIDAD' | translate}}">
        <form [formGroup]="formulario" (ngSubmit)="onSubmit()" novalidate id="fMatrizIdentidadAdd"
              name="nomMatrizIdentidadAdd">
          <div class="grid form-group">

            <div class="col-12 md:col-6 lg:col-6">
              <div class="div-form">
                <label>{{'MATRIZIDENTIDAD.LBL_CANAL' | translate}}:</label>
                <p-multiSelect id="idCanal" name="nomCanal" [options]="lisCanales"
                               filter="filter"
                               defaultLabel="{{ 'LBL_SELECCIONE' | translate}}"
                               selectedItemsLabel="{0} {{ 'LBL_ITEMSELECCIONADO' | translate}}"
                               formControlName="idCanal"
                               emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                               emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                               optionValue="value"
                               optionLabel="label"
                ></p-multiSelect>
                <div class="p-message p-messages-error p-corner-all"
                     *ngIf="submitted && f.idCanal.invalid">
                  {{ 'MATRIZIDENTIDAD.LBL_CANAL' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                </div>
              </div>
            </div>

            <div class="col-12 md:col-6 lg:col-6">
              <div class="div-form">
                <label>{{'MATRIZIDENTIDAD.LBL_TIPOCLIENTE' | translate}}:</label>

                <p-multiSelect id="idTipoCliente" name="nomTipoCliente" [options]="lisTipoCliente"
                               filter="filter"
                               defaultLabel="{{ 'LBL_SELECCIONE' | translate}}"
                               selectedItemsLabel="{0} {{ 'LBL_ITEMSELECCIONADO' | translate}}"
                               formControlName="idTipoCliente"
                               emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                               emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                               optionValue="value"
                               optionLabel="label"
                ></p-multiSelect>
                <div class="p-message p-messages-error p-corner-all"
                     *ngIf="submitted && f.idTipoCliente.invalid">
                  {{ 'MATRIZIDENTIDAD.LBL_TIPOCLIENTE' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                </div>
              </div>
            </div>

          </div>

          <div class="grid form-group">

            <div class="col-12 md:col-6 lg:col-6">
              <div class="div-form">
                <label>{{'MATRIZIDENTIDAD.LBL_MODOAUTENTICACION' | translate}}:</label>
                <p-dropdown disableTab  id="idModoAutenticacion" name="nomSeguro" [options]="lisModoAutenticacion"
                            placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                             formControlName="idModoAutenticacion" (onChange)="validarMetodoEspecifico()"
                ></p-dropdown>
                <div class="p-message p-messages-error p-corner-all"
                     *ngIf="submitted && f.idModoAutenticacion.invalid">
                  {{ 'MATRIZIDENTIDAD.LBL_MODOAUTENTICACION' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                </div>
              </div>
            </div>
            <div class="col-12 md:col-6 lg:col-6" *ngIf="esConfronta">
              <div class="col-12 md:col-2 lg:col-2">
                <p-checkbox label="{{ 'MATRIZIDENTIDAD.LBL_INDICADORMETODOOPCIONAL' | translate}}" binary="true"
                            id="indicadorMetodoOpcional"
                            name="nomindicadorMetodoOpcional"
                            formControlName="indicadorMetodoOpcional" (onChange)="validarCheckOpcional()"></p-checkbox>
              </div>
              <div class="col-12 md:col-10 lg:col-10" *ngIf="f.indicadorMetodoOpcional.value">
                <div class="div-form">
                  <label>{{'MATRIZIDENTIDAD.LBL_MODOAUTENTICACION' | translate}}:</label>
                  <p-dropdown disableTab  id="idModoAutenticacionOpcional" name="nomSeguro" [options]="lisModoAutenticacion"
                              placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                               formControlName="idModoAutenticacionOpcional"
                  ></p-dropdown>
                  <div class="p-message p-messages-error p-corner-all"
                       *ngIf="submitted && f.idModoAutenticacionOpcional.invalid">
                    {{ 'MATRIZIDENTIDAD.LBL_MODOAUTENTICACION' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="grid form-group" *ngIf="esConfronta">
            <div class="col-12 md:col-6 lg:col-6">
              <div class="div-form">
                <label>{{'MATRIZIDENTIDAD.LBL_TIPOCUESTIONARIO' | translate}}:</label>
                <p-dropdown disableTab  id="idTipoCuestionario" name="nomSeguro" [options]="lisTiposCuestionarios"
                            placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                             formControlName="idTipoCuestionario"
                ></p-dropdown>
                <div class="p-message p-messages-error p-corner-all"
                     *ngIf="submitted && f.idTipoCuestionario.invalid">
                  {{ 'MATRIZIDENTIDAD.LBL_TIPOCUESTIONARIO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                </div>
              </div>
            </div>
          </div>

          <div class="grid form-group">
            <div class="col-12 md:col-2 lg:col-2">
              <p-checkbox label="{{ 'MATRIZIDENTIDAD.LBL_VALIDACIONIDENTIDAD' | translate}}" binary="true"
                          id="indicadorValidacionIdentidad"
                          name="nomindicadorValidacionIdentidad"
                          formControlName="indicadorValidacionIdentidad" (onChange)="metodoCheckeado()"></p-checkbox>
            </div>

            <div class="col-12 md:col-2 lg:col-2">
              <div class="div-form">
                <p-checkbox label="{{ 'MATRIZIDENTIDAD.LBL_TOMADATOS' | translate}}" binary="true"
                            id="indicadorTomaDatos"
                            name="nomindicadorTomaDatosr"
                            formControlName="indicadorTomaDatos" (onChange)="setearIndicadorObligatorio()"></p-checkbox>
              </div>
            </div>

            <div class="col-12 md:col-2 lg:col-2" *ngIf="f.indicadorTomaDatos.value">
              <div class="div-form">
                <p-checkbox label="{{ 'MATRIZIDENTIDAD.LBL_INDICADOROBLIGATORIO' | translate}}" binary="true"
                            id="indicadorObligatorio"
                            name="indicadorObligatorio"
                            formControlName="indicadorObligatorio" (onChange)="metodoCheckeado()"></p-checkbox>
              </div>
            </div>

            <div class="col-12 md:col-2 lg:col-2">
              <p-checkbox label="{{ 'LBL_HABILITADO' | translate}}" binary="true"
                          id="indicador"
                          name="nomIndicador"
                          formControlName="indicadorHabilitado" (onChange)="metodoCheckeado()"></p-checkbox>
            </div>
          </div>
          <div class="grid form-group">
            <div class="div-form">
              <div class="p-message p-messages-error p-corner-all"
                   *ngIf="validacionIdentidad">
                {{ mensajeError }}
              </div>
              <div class="p-message p-messages-error p-corner-all"
                   *ngIf="submitted && validacionIdentidad">
                {{ 'MATRIZIDENTIDAD.MSG_ERRORINDICADOR' | translate }}
              </div>
            </div>
          </div>

          <div class="grid form-footer-buttons">
            <div class="form-group col-12">
              <div *ngIf="!agregar">
                <button icon="fa fa-floppy-o" label="{{'BTN_AGREGAR' | translate }}"
                        type="submit"
                        pButton></button>
              </div>
              <div *ngIf="agregar">
                <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
                <span>{{'LBL_GUARDANDO' | translate }}</span>
              </div>
            </div>
          </div>
        </form>


        <div class="grid">
          <div class="col-12 md:col-12 lg:col-12">
            <p-table [columns]="columnas" #dt
                     [value]="listaMatrizIdentidadTemp" selectionMode="single" dataKey="idMatrizIdentidad"
                     [paginator]="true" [rows]="10"  paginatorPosition="bottom">
              <ng-template pTemplate="header" let-columns>
                <tr>
                  <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
                    {{col.header}}
                    <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
                  </th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-row>
                <tr [pSelectableRow]="row">
                  <td>{{row.nombreModoAutenticacion}}</td>
                  <td class="text-center">
                    <p-checkbox [(ngModel)]="row.indicadorValidacionIdentidad" binary="true" disabled="true"></p-checkbox>
                  </td>
                  <td class="text-center">
                    <p-checkbox [(ngModel)]="row.indicadorTomaDatos" binary="true" disabled="true"></p-checkbox>
                  </td>
                  <td class="text-center">
                    <p-checkbox [(ngModel)]="row.indicadorObligatorio" binary="true" disabled="true"></p-checkbox>
                  </td>
                  <td class="text-center">
                    <p-checkbox [(ngModel)]="row.indicadorHabilitado" binary="true" disabled="true"></p-checkbox>
                  </td>
                  <td class="text-center">
                    <div class="btn-group" role="group">
                      <button type="button" class="p-button p-button-danger btn" icon="fa fa-trash" data-toggle="tooltip"
                              title="{{'BTN_DESHABILITAR' | translate}}" pButton
                              (click)="disable(row)" ></button>
                    </div>
                  </td>
                </tr>
              </ng-template>
              <ng-template pTemplate="emptymessage" let-columns>
                <tr>
                  <td [attr.colspan]="columns.length">
                    {{ 'MSG_NOHAYREGISTROS' | translate}}
                  </td>

                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>

        <div class="grid form-footer-buttons">
          <div class="form-group col-12">
            <div *ngIf="!guardando">
              <a (click)="regresar(formulario.dirty)" class="cancelar">{{'BTN_CANCELAR' | translate }}</a>
              <button icon="fa fa-floppy-o" label="{{'BTN_GUARDAR' | translate }}"
                      type="submit"
                      pButton (click)="add()"></button>
            </div>
            <div *ngIf="guardando">
              <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
              <span>{{'LBL_GUARDANDO' | translate }}</span>
            </div>
          </div>
        </div>

      </p-panel>
    </div>
  </div>
</div>




<p-confirmDialog #cd key="matriz-identidad">
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>
